export type IBppFormSixthSectionInterface = {
    MarketValue20K?: string,
    MarketValue125K?: string,
    IsMarketValueCertified? : boolean,
}


export const SixthSectionInitialState = {
    MarketValue20K: undefined,
    MarketValue125K: undefined,
    IsMarketValueCertified: undefined
}